import { TApiErrorCodes } from 'api/errors'

export interface IApiErrorCause {
  status: number
  code: string
  meta?: Record<string, unknown>
}

export class ApiError extends Error {
  public errorCode?: TApiErrorCodes
  constructor(
    error: Error,
    public cause: IApiErrorCause
  ) {
    super(error.message)
    this.name = `[API_ERROR] ${error.message}`
  }
}

// Draft-cap rejection arrives as a plain Error with `cause` (api-factory
// successHandler), not an ApiError instance — narrow on the cause shape.
// meta.draftLimit is the discriminator; 409/Conflict alone is too broad.
export const isDraftLimitError = (error: unknown): boolean => {
  const cause = (error as { cause?: IApiErrorCause } | null)?.cause
  return (
    cause?.status === 409 &&
    cause?.code === 'Conflict' &&
    cause?.meta?.draftLimit !== undefined
  )
}

export class ReduxThunkError extends Error {
  constructor(error: Error | unknown) {
    super(error instanceof Error ? error.message : 'Unknown error')
    this.name = `[REDUX_THUNK_ERROR] ${error instanceof Error ? error.message : 'Unknown error'}`
  }
}

export class ReportedIssue extends Error {
  constructor(message: string) {
    super(message)
    this.name = `[REPORTED_ISSUE] ${message}`
  }
}
